module.exports = __webpack_public_path__ + "assets/img/destroy_team.6b1e78ea.png";